export const locale = {
    lang: 'es',
    data: {
        INVENTARIO: {
            LIST: {
                TITLE: 'INVENTARIO'
            }
        }
    }
};
